export default {
  KEY_TOKEN: 'gpuass_token',
  KEY_INFO: 'gpuass_info',
  KEY_LANG: 'gpuass_lang',
  // 站点形态记忆（'pc' / 'wap'）：用户在手机上选择过 PC 版后，不再自动跳到 wap 子域
  KEY_VIEW: 'gpuass_view',
}
